module.exports = __webpack_public_path__ + "static/media/launch_transitional_marker.6c3ff715.svg";